<template>
    <div>
        <div style="margin-bottom: 5px">
            <el-input
                v-model="name"
                placeholder="请输入商品名称"
                suffix-icon="el-icon-a-042"
                style="width: 200px"
                @keyup.enter.native="loadPost"
            ></el-input>
            <el-button
                type="primary"
                style="margin-left: 5px; font-size: 18px"
                @click="loadPost"
            >
                查询</el-button
            >
            <el-button
                type="warning"
                @click="resetParam"
                style="font-size: 18px"
            >
                重置</el-button
            >

        </div>
        <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
            border
        >
            <!-- <el-table-column prop="id" label="ID" width="60"> </el-table-column> -->
            <!-- <el-table-column prop="userOrderNo" label="订货单号" ></el-table-column> -->
			<el-table-column prop="goodsName" label="商品名称"width="100"></el-table-column>
			<el-table-column prop="fee" label="单价" width="60"></el-table-column>
			<el-table-column prop="goodsNum" label="订货数量" width="80"></el-table-column>
			<el-table-column prop="unit" label="商品单位" width="80"></el-table-column>
			<el-table-column prop="totalMoney" label="总价" width="80"></el-table-column>
			<el-table-column prop="orderStatus" label="订货状态" width="80" :formatter="orderInfoState"></el-table-column>
			<el-table-column prop="buyTime" label="进货时间" width="180"></el-table-column>
            <el-table-column prop="remarks" label="备注" width="180"> </el-table-column>
            <el-table-column
                prop="operate"
                label="操作"
                width="240"
                fixed="right"
            >
                <template slot-scope="scope">
					<el-popconfirm
					    title="确定已进货吗？"
					    @confirm="doMod(scope.row,2)"
					    style="margin-left: 5px"
						v-if="scope.row.orderStatus==1"
					>
					    <el-button
					        slot="reference"
					        type="warning"
					        style="font-size: 18px"
					    >
					        已进货</el-button
					    >
					</el-popconfirm>
					
					<el-popconfirm
					    title="确定取消吗？"
					    @confirm="doMod(scope.row,3)"
					    style="margin-left: 5px"
						v-if="scope.row.orderStatus==1"
					>
					    <el-button
					        slot="reference"
					        type="success"
					        style="font-size: 18px"
					    >
					        取消</el-button
					    >
					</el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
    </div>
</template>

<script>
	import SelectGoods from "../goods/SelectGoods";
export default {
    name: "UserOrderInfo",
	components: {SelectGoods },
    data() {
        return {
			tempGoods:{},
            tableData: [],
            pageSize: 10,
            pageNum: 1,
            total: 0,
            name: "",
			innerVisible: false,
            centerDialogVisible: false,
			orderInfoGoodsDialogVisible:false,
			voiceGoodsDialogVisible:false,
			editOrderInfoDialogVisible:false,
            form: {
                id: "",
                userId: "",
                userName: "",
				orderStatus:"1",
				remarks:""
            },
			orderInfo:{
				id:"",
				userOrderId:"",
				userOrderNo:"",
				goodsId:"",
				goodsName:"",
				goodsNum:"",
				remarks:"",
				fee:"",
				unit:"",
				goodsStr:""
			},
            rules: {
                userName: [
                    {
                        required: true,
                        message: "请选择下单人",
                        trigger: "blur",
                    },
                ],
            },
			orderInfoRules: {
			    goodsName: [
			        {
			            required: true,
			            message: "请选择商品",
			            trigger: "blur",
			        },
			    ],
				goodsNum: [
				    {
				        required: true,
				        message: "请输入商品数量",
				        trigger: "blur",
				    },
				],
			},
			// 进货状态：1待进货，2已进货，3已取消
			orderInfoStatus:[
				{
					id:1,
					name:"待进货"
				},
				{
					id:2,
					name:"已进货"
				},
				{
					id:3,
					name:"已取消"
				}
			]
        };
    },
	props:{
		userOrderId:{
			type:Number,
			default:""
		},
		userOrderNo:{
			type:String,
			default:""
		},
	},
	watch:{
		userOrderId:{
			handler(newVal,oldVal){
				console.log("userOrderIdnewVal:"+newVal)
				if(newVal){
					this.orderInfo.userOrderId=newVal;
					this.loadPost()
				}
			},
			deep:true,
			immediate:true
		},
		userOrderNo:{
			handler(newVal,oldVal){
				console.log("userOrderNonewVal:"+newVal)
				if(newVal){
					this.orderInfo.userOrderNo=newVal;
				}
			},
			deep:true,
			immediate:true
		}
	},
    methods: {
		doMod(row,status) {
			row.orderStatus=status
		    this.$axios
		        .post(this.$httpUrl + "/buyorderinfo/update", row)
		        .then((res) => res.data)
		        .then((res) => {
		            console.log(res);
		            if (res.code == 200) {
		                this.$message({
		                    message: "操作成功！",
		                    type: "success",
		                });
		                this.centerDialogVisible = false;
		                this.loadPost();
		                this.resetForm();
		            } else {
		                this.$message({
		                    message: "操作失败！",
		                    type: "error",
		                });
		            }
		        });
		},
		orderInfoState(row){
			let temp = this.orderInfoStatus.find((item) => {
			    return item.id == row.orderStatus;
			});
			
			return temp && temp.name;
		},
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageNum = 1;
            this.pageSize = val;
            this.loadPost();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val;
            this.loadPost();
        },
        resetParam() {
            this.name = "";
        },
        loadPost() {
            this.$axios
                .post(this.$httpUrl + "/buyorderinfo/listPage", {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: {
                        goodsName: this.name,
						buyOrderId:this.userOrderId
                    },
                })
                .then((res) => res.data)
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.tableData = res.data;
                        this.total = res.total;
                    } else {
                        alert("获取数据失败");
                    }
                });
        },
    },
	
    beforeMount() {
        this.loadPost();
    },
};
</script>

<style scoped>
</style>